"use strict";function requestAuthCode$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.requestAuthCode$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="channel.permission.requestAuthCode";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.0.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.0.0"},_a)),exports.requestAuthCode$=requestAuthCode$,exports.default=requestAuthCode$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/channel/permission/requestAuthCode.js
// module id = 1038
// module chunks = 106